import { render, staticRenderFns } from "./UserGroupUserDeleteModal.vue?vue&type=template&id=bdc992ea&scoped=true&"
import script from "./UserGroupUserDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./UserGroupUserDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc992ea",
  null
  
)

export default component.exports